import React, { Component, createRef } from "react";
import news1 from "../../assets/img/news1.png";
import news2 from "../../assets/img/news2.png";
import news3 from "../../assets/img/news3.png";
import news4 from "../../assets/img/news4.png";
import cta1 from "../../assets/img/1.png";
import cta2 from "../../assets/img/2.png";
import cta3 from "../../assets/img/3.png";
import cta4 from "../../assets/img/4.png";

import "./footer.css";
import { Button } from "react-bootstrap";

class FooterInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cta: createRef(),
			visible: false,
		};
	}
	toDown() {
		this.state.cta.current.scrollIntoView({
			behavior: "smooth",
			block: "end",
		});
	}
	handleScroll = () => {
		const currentScrollPos = window.scrollY;
		const { offsetTop } = this.state.cta.current;
		const visible =
			currentScrollPos > 600 && currentScrollPos < offsetTop - 500;
		this.setState({
			visible,
		});
	};

	componentDidMount() {
		window.addEventListener("scroll", this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	}
	render() {
		return (
			<section className='container'>
				<a
					href='https://fullmusculo.com/pack-entrenador-2/'
					className={`navigate-button ${this.state.visible ? "show" : null}`}
				>
					Click Aquí para Empezar a Entrenar de Forma Efectiva
				</a>
				<div className={"info"} ref={this.state.cta}>
					<h1>SÉ TU PROPIO ENTRENADOR</h1>
					<div className='container cta'>
						<p>
							Entrena de forma efectiva para ganar masa muscular y perder grasa,
							SIN tener que entrenar todos los días, sin importar que entrenes
							en tu casa o el gym, incluso sin tener experiencia previa
							entrenando o conocimiento.
						</p>
						<a
							className={"btn-primary"}
							href='https://fullmusculo.com/pack-entrenador-2/'
						>
							EMPIEZA AHORA
						</a>
					</div>
				</div>
				<div className='info-news'>
					<h1
						style={{
							textAlign: "center",
							textTransform: "uppercase",
							fontFamily: "Anton-Regular, sans-serif",
							marginBottom: "2rem",
						}}
					>
						HEMOS SIDO PRESENTADOS POR
					</h1>
					<div className='images-container'>
						<img src={news1} alt='news' />
						<img src={news2} alt='news' style={{ width: "150px" }} />
						<img src={news3} alt='news' style={{ width: "290px" }} />
						<img src={news4} alt='news' />
					</div>
				</div>
			</section>
		);
	}
}

export default FooterInfo;
